import styled from "styled-components";
import color from "../../config/color.js";

export const Container = styled.div`
  margin-left: 12.5%;
  max-width: 60em;
  @media (max-width: 600px) {
    margin-left: auto;
  }
`;

export const WalletButton = styled.div`
  border-radius: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-size: 1.8em;
  height: 80px;
  width: 80px;
  font-weight: bold;
  color: ${color.white};
  background: ${color.darkOrange};
  padding: 20px;
`;

export const FancyLabel = styled.div`
  width: 60px;
  background: ${props => props.color || color.blue};
  border-radius: 10px;
  color: ${color.white};
  font-size: 1.8em;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
`;

export const TransactionCard = styled.div`
  border: 2px solid;
  border-color: ${props => props.theme.palette.primary["400"]};
  background: ${props => props.theme.palette.primary["100"]};
  border-radius: 10px;
  margin: 10px;
  padding: 10px;
`;
